// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { ChargeItemDefinitionGetResponse } from '@quromedical/models';
import type { ColumnType } from 'components/table';
import {
  ChargeItemDefinitionForm,
  type ChargeItemDefinition as FormData,
  mapFormDataToChargeItemRequest,
} from 'core/claim';
import { PaginatedTable } from 'core/table';
import { Section, ToggleCard } from 'design-system';
import { router } from 'expo-router';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useRevalidation } from 'hooks/useRevalidation';
import {
  administratorCodeFetcher,
  organizationSchemeCodeFetcher,
} from 'integration';
import { ChargeItemApi } from 'integration/aggregate';
import type { GroupStackScreenProps } from 'navigation';
import type React from 'react';
import { useCallback } from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';

const api = new ChargeItemApi();

const columns: ColumnType<ChargeItemDefinitionGetResponse>[] = [
  {
    accessor: 'title',
    header: strings.ChargeItemDefinitionFormLabelName,
  },
  {
    accessor: 'description',
    header: strings.ChargeItemDefinitionFormLabelDescription,
  },
];

export const ChargeItemListScreen: React.FC<
  GroupStackScreenProps<'List'>
> = () => {
  const baseSWRKey = 'charge-item-list';

  const revalidate = useRevalidation(baseSWRKey);

  const handleSubmit = useCallback(
    async (data: FormData) => {
      const chargeItem = mapFormDataToChargeItemRequest(data);

      await api.createChargeItem(chargeItem);

      await revalidate();
    },
    [revalidate],
  );

  const fetcher = (options?: FetcherOptions) =>
    api.getChargeItems({
      pageToken: options?.nextToken,
      ...options,
    });

  const onRowPress = useCallback((row: ChargeItemDefinitionGetResponse) => {
    const id = row.id;
    if (!id) {
      return;
    }

    router.push({
      pathname: `/admin/charge-item/${id}`,
    });
  }, []);

  return (
    <ScrollView>
      <Section unsetZIndex>
        <ToggleCard
          title={strings.ChargeItemDefinitionFormCreateTitle}
          icon="attach-money"
          textExpand={strings.LabelExpand}
          textCollapse={strings.LabelCollapse}
        >
          <ChargeItemDefinitionForm
            hideCard
            schemeFetcher={organizationSchemeCodeFetcher}
            administratorFetcher={administratorCodeFetcher}
            onSubmit={handleSubmit}
          />
        </ToggleCard>
      </Section>
      <Section>
        <PaginatedTable
          cacheKey={baseSWRKey}
          fetcher={fetcher}
          columns={columns}
          getDataFromResponse={(res) => res.chargeItemDefinitions}
          canChangeCount
          onRowPress={onRowPress}
        />
      </Section>
    </ScrollView>
  );
};
